export default {
  // Hero
  zimmerKicker: 'Unsere Zimmer',
  zimmerHeroTitle1: 'Ankommen. Wohlfühlen.',
  zimmerHeroTitle2: 'Bleiben wollen.',
  zimmerHeroLead: 'Drei Zimmerkategorien. Ein Versprechen: Ruhe, Komfort und das Gefühl, willkommen zu sein.',

  // Sticky filter
  zimmerFilterAll: 'Alle Zimmer',
  zimmerFilterDoppel: 'Doppelzimmer',
  zimmerFilterEinzel: 'Einzelzimmer',
  zimmerFilterKomfort: 'Komfort-Doppelzimmer',

  // Kachel-Prefix
  zimmerPrefixDZ: 'Doppelzimmer',
  zimmerPrefixEZ: 'Einzelzimmer',

  // Doppelzimmer card
  zimmerDZTitle: 'Doppelzimmer',
  zimmerDZSize: 'ca. 20 m²',
  zimmerDZGuests: '2 Personen',
  zimmerDZPrice: 'ab 179 €',
  zimmerDZPriceNote: 'pro Nacht inkl. Frühstück',
  zimmerDZTag1: 'Eigenes Badezimmer',
  zimmerDZTag2: 'Kostenfreies WLAN',
  zimmerDZTag3: 'Kostenfreie Parkplätze',
  zimmerDZDescription: 'Sehr bequeme Betten. Matratzen in zwei Härtegraden. Auf Wunsch Kissen und Oberbetten zur Auswahl: allergikergeeignet, Dinkel-Kissen, zusätzliche Topper oder Sommerbetten etc.',

  // Einzelzimmer card
  zimmerEZTitle: 'Einzelzimmer',
  zimmerEZSize: '7 – 11 m²',
  zimmerEZGuests: '1 Person',
  zimmerEZPrice: 'ab 99 €',
  zimmerEZTag1: 'Blick ins Grüne',
  zimmerEZTag2: 'Eigenes Badezimmer',
  zimmerEZTag3: 'Kostenfreies WLAN',
  zimmerEZTag4: 'Kostenfreie Parkplätze',
  zimmerEZDescription: 'Sehr bequemes Bett. Auf Wunsch Kissen und Oberbetten zur Auswahl: allergikergeeignet, Dinkel-Kissen, zusätzliche Topper oder Sommerbetten etc.',

  // Komfort
  zimmerKomfortTitle: 'Komfort-Doppelzimmer',
  zimmerKomfortSize: 'ca. 30 m²',
  zimmerKomfortGuests: '2 Personen',
  zimmerKomfortPrice: 'ab 199 €',
  zimmerKomfortTag1: 'Wohn- & Schlafraum',
  zimmerKomfortTag2: 'Gartenblick',
  zimmerKomfortTag3: 'Eigenes Badezimmer',
  zimmerKomfortTag4: 'Kostenfreies WLAN',
  zimmerKomfortTag5: 'Kostenfreie Parkplätze',
  zimmerKomfortDescription: 'Sehr bequeme Betten. Matratzen in zwei Härtegraden. Auf Wunsch Kissen und Oberbetten zur Auswahl: allergikergeeignet, Dinkel-Kissen, zusätzliche Topper oder Sommerbetten etc.',

  // Buttons
  zimmerToggleAmenitiesShow: 'Ausstattung anzeigen',
  zimmerToggleAmenitiesHide: 'Weniger anzeigen',
  zimmerAmenitiesTitle: 'Ausstattung im Detail',
  zimmerToggleAllDZShow: 'Alle Doppelzimmer anzeigen',
  zimmerToggleAllDZHide: 'Weniger anzeigen',
  zimmerToggleAllEZShow: 'Alle Einzelzimmer anzeigen',
  zimmerToggleAllEZHide: 'Weniger anzeigen',
  zimmerBookCta: 'Jetzt buchen',

  // Amenities (DZ + EZ)
  amenitySitzbereich: 'Sitzbereich',
  amenitySafe: 'Safe',
  amenityBad: 'Bad mit Dusche',
  amenitySchreibtisch: 'Schreibtisch',
  amenityTv: 'Flachbild-TV/Radio',
  amenityPflege: 'Hochwertige Pflegeprodukte',
  amenityTeppich: 'Teppichboden',
  amenitySat: 'Satellitenempfang',
  amenityHaartrockner: 'Haartrockner',
  amenitySchrank: 'Schrank',
  amenityTel: 'Telefon/Weckservice',
  amenityHausschuhe: 'Hausschuhe',
  amenityWohnSchlaf: 'Wohn- und Schlafzimmer',

  // Wichtige Infos
  zimmerInfoTitle: 'Wichtige Informationen',
  zimmerInfoCheckin: 'Check-in:',
  zimmerInfoCheckinValue: 'ab 15 Uhr',
  zimmerInfoCheckout: 'Check-out:',
  zimmerInfoCheckoutValue: 'bis 12 Uhr',
  zimmerInfoBreakfast: 'Frühstück:',
  zimmerInfoBreakfastValue: '7–10 Uhr, Wochenende/Feiertags 8–11 Uhr',
  zimmerInfoParking: 'Parkplätze:',
  zimmerInfoParkingValue: 'kostenfrei',
  zimmerInfoWifi: 'WLAN:',
  zimmerInfoWifiValue: 'kostenlos',
  zimmerInfoPets: 'Haustiere:',
  zimmerInfoPetsValue: 'aus Rücksicht auf Allergiker nicht erlaubt',

  // CTA
  zimmerCtaTitle: 'Bereit für Ihren Aufenthalt?',
  zimmerCtaText: 'Wählen Sie Ihr Zimmer, prüfen Sie die Verfügbarkeit und freuen Sie sich auf erholsame Tage im Alpenhof.',
  zimmerCtaButton: 'Jetzt Verfügbarkeit prüfen',
};
